<div class="modal-view">
    <div class="" ui-view></div>
</div>